import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import EsyohWidget887570 from './EsyohWidget887570';

const { FiSearch, FiMessageSquare, FiAward } = FiIcons;

const steps = [
  {
    icon: FiSearch,
    title: 'Research Programs',
    text: 'Decide whether you need beginner training, a short certificate, continuing education, or a pathway toward an advanced technical career in New Jersey.',
  },
  {
    icon: FiMessageSquare,
    title: 'Request Information',
    text: 'Confirm lab hours, electrical and refrigeration coverage, EPA Section 608 preparation, schedule, tuition, tools, externships, and career services.',
  },
  {
    icon: FiAward,
    title: 'Choose Your Path',
    text: 'Choose New Jersey training that supports your goals, then continue developing through certifications, supervised field experience, and advanced technical practice.',
  },
];

function Process() {
  return (
    <section className="process-section section">
      <EsyohWidget887570 />
      <div className="section-heading">
        <p className="eyebrow">Your next chapter</p>
        <h2>Start Your HVAC Career in New Jersey</h2>
        <p>
          HVAC is a practical career with several entry points. Some students
          begin with a short program and pursue entry-level maintenance work.
          Others choose a longer technical pathway, specialize in commercial
          refrigeration, or use training as the foundation for an eventual
          contractor or business career.
        </p>
      </div>
      <div className="steps">
        <div className="step-line" aria-hidden="true" />
        {steps.map((step, index) => (
          <article className="step" key={step.title}>
            <div className="step-icon">
              <SafeIcon icon={step.icon} />
              <span>{index + 1}</span>
            </div>
            <div>
              <small>Step {index + 1}</small>
              <h3>{step.title}</h3>
              <p>{step.text}</p>
            </div>
          </article>
        ))}
      </div>
      <button
        className="secondary-button"
        onClick={() => document.getElementById('programs')?.scrollIntoView({ behavior: 'smooth' })}
      >
        Compare New Jersey HVAC programs
      </button>
    </section>
  );
}

export default Process;